module.exports = __webpack_public_path__ + "static/media/mother-giving-baby-boy-massage.38fef5ba.jpg";